<template>
  <div class="mode-options-container text-center">
    <p class="text-muted lead mb-4">{{ t("Choose how you want to register") }}</p>

    <div class="row g-4 justify-content-center">
      <!-- Zamawiam dla siebie -->
      <div v-if="modes.includes('institution_worker')" class="col-12 col-sm-6">
        <div class="mode-card-wrapper">
          <button
            type="button"
            class="mode-card w-100 p-4 d-flex flex-column align-items-center justify-content-center"
            @click="$emit('select', 'institution_worker')"
          >
            <div class="mode-icon mb-3">
              <i class="fa fa-user"></i>
            </div>

            <span class="mode-card-title mb-2">{{ t("I order for myself") }}</span>

            <span class="text-muted small mb-0">
              {{ t("Single user account with one calendar") }}
            </span>
          </button>

          <div class="more-info-toggle mt-2">
            <a href="#" class="small" @click.prevent="showWorkerInfo = !showWorkerInfo">
              <i :class="showWorkerInfo ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="me-1" />
              {{ t("More info") }}
            </a>
          </div>

          <b-collapse v-model="showWorkerInfo">
            <div class="more-info-content mt-2 p-3 text-start">
              <ul class="mb-0 ps-3">
                <li>{{ t("registration_info.worker.single_account") }}</li>
                <li>{{ t("registration_info.worker.one_calendar") }}</li>
                <li>{{ t("registration_info.worker.ideal_for_employees") }}</li>
              </ul>
            </div>
          </b-collapse>
        </div>
      </div>

      <!-- Zamawiam dla dziecka -->
      <div v-if="modes.includes('parent')" class="col-12 col-sm-6">
        <div class="mode-card-wrapper">
          <button
            type="button"
            class="mode-card w-100 p-4 d-flex flex-column align-items-center justify-content-center"
            @click="$emit('select', 'parent')"
          >
            <div class="mode-icon mb-3">
              <i class="fa fa-users"></i>
            </div>

            <span class="mode-card-title mb-2">{{ t("I order for child") }}</span>

            <span class="text-muted small mb-0">
              {{ t("Parent account with multiple meal receivers") }}
            </span>
          </button>

          <div class="more-info-toggle mt-2">
            <a href="#" class="small" @click.prevent="showParentInfo = !showParentInfo">
              <i :class="showParentInfo ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="me-1" />
              {{ t("More info") }}
            </a>
          </div>

          <b-collapse v-model="showParentInfo">
            <div class="more-info-content mt-2 p-3 text-start">
              <ul class="mb-0 ps-3">
                <li>{{ t("registration_info.parent.multiple_receivers") }}</li>
                <li>{{ t("registration_info.parent.separate_calendars") }}</li>
                <li>{{ t("registration_info.parent.ideal_for_parents") }}</li>
              </ul>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import type { RegistrationMode } from "../queries/useRegisterModesQuery";

defineProps<{
  modes: RegistrationMode[];
}>();

defineEmits<{
  select: [mode: RegistrationMode];
}>();

const { t } = useI18n();

const showWorkerInfo = ref(false);
const showParentInfo = ref(false);
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.mode-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 200px;
}

.mode-card:hover {
  border-color: $primary;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transform: translateY(-4px);
}

.mode-card:focus {
  outline: none;
  border-color: $primary;
  box-shadow: 0 0 0 3px rgba($primary, 0.25);
}

.mode-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  color: #373a3e;
  transition: all 0.25s ease;
}

.mode-card:hover .mode-icon {
  transform: scale(1.15);
  color: $primary;
}

.mode-card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #373a3e;
}

.mode-card:hover .mode-card-title {
  color: $primary;
}

.more-info-toggle {
  text-align: center;

  a {
    color: #6c757d;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: $primary;
    }
  }
}

.more-info-content {
  background: #f8f9fa;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #495057;

  ul {
    list-style-type: disc;

    li {
      margin-bottom: 0.25rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
